const zoneFaq = (zona) => [
  {
    q: `¿Cuánto cuesta la hectárea en ${zona}?`,
    a: "Depende del cultivo, la dosis y el acceso al lote. Nos pasás cultivo y hectáreas por WhatsApp y te devolvemos el precio por hectárea el mismo día.",
  },
  {
    q: "¿Cuánto tardan en llegar al lote?",
    a: "Coordinamos según la ventana de tu cultivo. En zonas activas programamos entre 24 y 72 horas; en época de pico conviene reservar con anticipación.",
  },
  {
    q: "¿Aplican con viento o de noche?",
    a: "El viento se mide antes de cada vuelo y se respeta el límite del protocolo. Cuando conviene, aplicamos de noche: menos viento, menos deriva y mejor depósito.",
  },
];

const serviceFaq = [
  {
    q: "¿Cuánto cuesta la aplicación por hectárea?",
    a: "El precio es por hectárea y depende del cultivo, la dosis y la zona. Completás el cotizador o nos escribís por WhatsApp y te lo devolvemos el mismo día.",
  },
  {
    q: "¿El dron rinde igual que un avión o un equipo terrestre?",
    a: "En lotes chicos, irregulares o con barro, el dron rinde más porque despega desde el borde del lote y no pisa el cultivo. En macrolotes planos de 1.000+ ha seguidas, el avión sigue ganando y te lo decimos.",
  },
  {
    q: "¿Qué pasa si llueve o hay viento el día de la aplicación?",
    a: "Se mide el viento antes de cada vuelo y se reprograma sin costo si las condiciones salen del protocolo. Cuando conviene, aplicamos de noche: menos viento y mejor depósito.",
  },
];

const ZONES = [
  {
    slug: "/zonas/cuatro-canadas",
    name: "Cuatro Cañadas",
    title: "Aplicación Agrícola con Drones en Cuatro Cañadas | Fumiga",
    meta: "Servicio de aplicación agrícola con drones en Cuatro Cañadas: soya, sorgo y maíz. Llegamos a tu lote en 48 horas. Cotizá por WhatsApp.",
    intro: "Servicio de aplicación agrícola con drones en Cuatro Cañadas y alrededores. Soya, sorgo y maíz de verano, con llegada a tu lote en 48 horas coordinadas por WhatsApp.",
    crops: ["Soya de verano", "Sorgo", "Maíz"],
  },
  {
    slug: "/zonas/pailon",
    name: "Pailón",
    title: "Aplicación Agrícola con Drones en Pailón | Fumiga",
    meta: "Aplicamos tus cultivos con dron en Pailón y alrededores. Cobertura por hectárea, sin pisar el lote. Pedí tu cotización hoy.",
    intro: "Aplicación con dron en Pailón y alrededores. Cobertura por hectárea sin pisar el lote, con ficha técnica firmada al terminar cada jornada.",
    crops: ["Caña de azúcar", "Soya", "Pasturas"],
  },
  {
    slug: "/zonas/san-julian",
    name: "San Julián",
    title: "Aplicación Agrícola con Drones en San Julián | Fumiga",
    meta: "Aplicación agrícola con drones en San Julián: soya, maíz y sorgo. Programamos tu aplicación según el estado del cultivo. Cotizá ahora.",
    intro: "Aplicación agrícola con drones en San Julián: soya, maíz y sorgo. Programamos tu aplicación según el estado real del cultivo, no según el calendario del contratista.",
    crops: ["Soya", "Maíz", "Sorgo"],
  },
  {
    slug: "/zonas/okinawa",
    name: "Okinawa",
    title: "Aplicación Agrícola con Drones en Okinawa | Fumiga",
    meta: "Servicio de aplicación con dron en la colonia Okinawa: soya, sorgo y trigo. Cotización por hectárea en el día.",
    intro: "Servicio de aplicación con dron en la colonia Okinawa: soya, sorgo y trigo. Cotización por hectárea en el día, directo por WhatsApp.",
    crops: ["Soya", "Sorgo", "Trigo"],
  },
  {
    slug: "/zonas/montero-mineros",
    name: "Montero y Mineros",
    title: "Aplicación Agrícola con Drones en Montero y Mineros | Fumiga",
    meta: "Aplicación con drones en Montero, Mineros y zona norte: caña, soya y maíz. Cotizá tus hectáreas por WhatsApp.",
    intro: "Aplicación con drones en Montero, Mineros y toda la zona norte: caña, soya y maíz. Cotizá tus hectáreas por WhatsApp y coordinamos la fecha.",
    crops: ["Caña de azúcar", "Soya", "Maíz"],
  },
  {
    slug: "/zonas/chiquitania",
    name: "la Chiquitania",
    title: "Aplicación Agrícola con Drones en la Chiquitania | Fumiga",
    meta: "Llegamos con drones a los lotes de la Chiquitania. Soya de verano y campaña de invierno. Consultá disponibilidad y precio.",
    intro: "Llegamos con drones a los lotes de la Chiquitania: soya de verano, girasol y campaña de invierno. Consultá disponibilidad y precio antes de la ventana.",
    crops: ["Soya de verano", "Girasol", "Campaña de invierno"],
  },
  {
    slug: "/zonas/santa-cruz",
    name: "Santa Cruz de la Sierra",
    title: "Aplicación Agrícola con Drones en Santa Cruz de la Sierra | Fumiga",
    meta: "Aplicación agrícola con drones en Santa Cruz de la Sierra, La Guardia, El Torno, Porongo y Cotoca. Cotización por hectárea en el día.",
    intro: "Base en Santa Cruz de la Sierra y cobertura en La Guardia, El Torno, Porongo y Cotoca. Y cuando el volumen lo justifica, coordinamos aplicaciones en el Beni y todo Bolivia.",
    crops: ["Hortícolas", "Pasturas", "Cítricos", "Soya", "Maíz", "Sorgo"],
  },
];

const zonePage = (z) => ({
  slug: z.slug,
  title: z.title,
  meta: z.meta,
  eyebrow: "Zona de cobertura · Santa Cruz",
  h1: `Aplicación agrícola con drones en ${z.name}`,
  intro: z.intro,
  area: `${z.name}, Santa Cruz, Bolivia`,
  wa: `Hola Fumiga, quiero cotizar aplicación con dron en ${z.name}.`,
  blocks: [
    {
      heading: `Cultivos que aplicamos en ${z.name}`,
      body: "Trabajamos los cultivos fuertes de la zona con dosis calibrada por lote y ficha técnica firmada al cierre de cada jornada.",
      bullets: z.crops,
    },
    {
      heading: "Cómo coordinamos tu aplicación",
      body: "Sin formularios eternos ni vueltas: tres pasos y el dron está sobre tu lote.",
      bullets: [
        "Nos escribís por WhatsApp con cultivo, hectáreas y zona",
        "Evaluamos el lote y la ventana de aplicación",
        "Aplicamos y te llevás la ficha técnica firmada",
      ],
    },
  ],
  faq: zoneFaq(z.name),
});

export const GENERIC_PAGES = [
  {
    slug: "/aplicacion-con-drones",
    title: "Drones Agrícolas en Bolivia: Cómo Trabajamos | Fumiga",
    meta: "Equipos, dosis, rendimiento por hora y condiciones de vuelo. Así aplicamos tus hectáreas con dron en Santa Cruz. Pedí tu cotización hoy.",
    eyebrow: "Servicio pilar",
    h1: "Así aplicamos tus hectáreas con dron",
    intro: "Equipos de gran porte, dosis calibrada por cultivo y un protocolo escrito. Esto es exactamente lo que pasa en tu lote cuando contratás a Fumiga.",
    area: "Santa Cruz de la Sierra, Bolivia",
    wa: "Hola Fumiga, quiero cotizar aplicación con dron para mi cultivo.",
    blocks: [
      {
        heading: "El equipo y la dosis",
        body: "Drones agrícolas de gran porte, operados por el responsable técnico en cada jornada. La dosis no se negocia: sale de la recomendación agronómica y queda registrada.",
        bullets: [
          "Tanque y boquillas calibrados por lote",
          "Litros por hectárea ajustados al cultivo",
          "Tamaño de gota según producto y clima",
        ],
      },
      {
        heading: "Rendimiento por hora",
        body: "Sin pista, sin traslados largos y sin esperar que el lote seque. El dron despega desde el borde y vuelve a cargar en minutos.",
        bullets: [
          "Más pasadas por día que equipo terrestre",
          "Despegue desde el borde del lote",
          "Acceso con suelo húmedo o barro",
        ],
      },
      {
        heading: "Condiciones de vuelo",
        body: "Cada vuelo cumple el protocolo propio de Fumiga, basado en referencia internacional y entregado por escrito.",
        bullets: [
          "Viento medido antes de cada pasada",
          "Aplicación nocturna cuando conviene",
          "Franjas de protección declaradas",
        ],
      },
    ],
    faq: serviceFaq,
  },
  {
    slug: "/soya",
    title: "Pulverización de Soya con Dron en Santa Cruz | Fumiga",
    meta: "Roya asiática, chinches y orugas: aplicamos tu soya en el momento justo de la campaña, sin pisar el lote. Cotizá por hectárea.",
    eyebrow: "Cultivo · Campaña de verano",
    h1: "Pulverización de soya con dron en Santa Cruz",
    intro: "La roya asiática, los chinches y las orugas no esperan a que haya pista libre. Aplicamos tu soya en el momento justo de la campaña, sin pisar el lote.",
    area: "Santa Cruz de la Sierra, Bolivia",
    wa: "Hola Fumiga, quiero cotizar pulverización de soya con dron.",
    blocks: [
      {
        heading: "Las plagas que no esperan",
        body: "En soya, la diferencia entre aplicar hoy y aplicar la semana que viene se mide en rendimiento. El dron entra cuando el cultivo lo necesita.",
        bullets: [
          "Roya asiática: cobertura foliar pareja, arriba y abajo de la hoja",
          "Chinches: aplicación en la ventana crítica",
          "Orugas: control antes de que cierren el dosel",
        ],
      },
      {
        heading: "Por qué dron en soya",
        body: "La soya de ciclo tardío cierra calle y el equipo terrestre pisa lo que ya no se recupera. El dron aplica sin tocar una planta.",
        bullets: [
          "Cero pisoteo de surcos",
          "Cobertura en canopia cerrada",
          "Ventana fuerte: diciembre a febrero",
        ],
      },
    ],
    faq: serviceFaq,
  },
  {
    slug: "/sorgo-y-maiz",
    title: "Pulverización de Sorgo y Maíz con Dron | Fumiga",
    meta: "Control de cogollero y plagas de campaña de invierno en sorgo y maíz con aplicación por dron en Santa Cruz. Pedí tu cotización.",
    eyebrow: "Cultivos · Campaña de invierno",
    h1: "Pulverización de sorgo y maíz con dron",
    intro: "El gusano cogollero trabaja de noche y en silencio. Nosotros también: aplicación con dron en la ventana crítica, en campaña de invierno y de verano.",
    area: "Santa Cruz de la Sierra, Bolivia",
    wa: "Hola Fumiga, quiero cotizar pulverización de sorgo y maíz con dron.",
    blocks: [
      {
        heading: "El cogollero en ventana crítica",
        body: "El control del cogollero se gana o se pierde en pocos días. Con el dron no dependés de pista ni de que el suelo esté firme.",
        bullets: [
          "Aplicación en la ventana crítica del cogollero",
          "Acceso inmediato después de lluvias",
          "Dosis registrada por hectárea",
        ],
      },
      {
        heading: "Campaña de invierno",
        body: "Siembra de abril a junio, aplicaciones de junio a agosto. Programamos tu lote antes de que se llene la agenda.",
        bullets: [
          "Sorgo y maíz de invierno",
          "Programación anticipada por lote",
          "Ficha técnica firmada al cierre",
        ],
      },
    ],
    faq: serviceFaq,
  },
  {
    slug: "/cana",
    title: "Desecante y Madurante en Caña con Dron | Fumiga",
    meta: "Aplicación de madurante y desecante en caña de azúcar con dron: dosis precisa y sin daño de rodado. Cotizá tus hectáreas.",
    eyebrow: "Cultivo · Pre-cosecha",
    h1: "Desecante y madurante en caña de azúcar",
    intro: "Cuando la caña está alta, el equipo terrestre ya no entra. El dron aplica madurante y desecante a la altura exacta, sin daño de rodado.",
    area: "Santa Cruz de la Sierra, Bolivia",
    wa: "Hola Fumiga, quiero cotizar aplicación en caña de azúcar con dron.",
    blocks: [
      {
        heading: "Caña alta, equipo fuera",
        body: "El rodado del equipo terrestre tumba y daña caña que ya está para cosecha. La aplicación aérea con dron no toca un solo tallo.",
        bullets: [
          "Madurante con dosis precisa por hectárea",
          "Desecante uniforme previo a la quema o corte",
          "Sin daño de rodado en caña en pie",
        ],
      },
      {
        heading: "Sincronizado con la zafra",
        body: "Coordinamos la aplicación con tu fecha de cosecha para que el madurante trabaje el tiempo justo: ni corto ni pasado.",
        bullets: [
          "Programación según fecha de corte",
          "Vuelo bajo y constante sobre la canopia",
          "Registro de vuelo por lote",
        ],
      },
    ],
    faq: serviceFaq,
  },
  {
    slug: "/siembra-y-fertilizacion",
    title: "Siembra de Cobertura y Fertilización con Dron | Fumiga",
    meta: "Sembramos cobertura y aplicamos fertilizante foliar con dron en Santa Cruz. Más pasadas por día y acceso a lotes con barro.",
    eyebrow: "Servicio · Cobertura y foliar",
    h1: "Siembra de cobertura y fertilización con dron",
    intro: "Sembramos cobertura y aplicamos fertilizante foliar con dron en Santa Cruz: más pasadas por día y acceso a lotes con barro donde nada más entra.",
    area: "Santa Cruz de la Sierra, Bolivia",
    wa: "Hola Fumiga, quiero cotizar siembra de cobertura o fertilización con dron.",
    blocks: [
      {
        heading: "Siembra de cobertura",
        body: "Brachiaria y coberturas de invierno sembradas por aire, con distribución pareja y sin compactar el suelo con maquinaria.",
        bullets: [
          "Distribución uniforme por hectárea",
          "Sin compactación ni surcos abiertos",
          "Ideal entre campañas",
        ],
      },
      {
        heading: "Fertilización foliar",
        body: "Nutrientes donde la planta los absorbe más rápido: la hoja. Con dosificación registrada en la ficha técnica de cada vuelo.",
        bullets: [
          "Dosis por hectárea registrada",
          "Acceso a lotes con barro",
          "Aplicación nocturna disponible",
        ],
      },
    ],
    faq: serviceFaq,
  },
  ...ZONES.map(zonePage),
];
